import React, { useState } from 'react';
import { DefaultThemed } from '../ThemeProvider/ThemeProvider';
import { ReactComponent as MinusIcon } from '../assets/svg/minus.svg';
import { ReactComponent as PlusIcon } from '../assets/svg/plus.svg';
import {
  ButtonWrapper,
  CounterContainer,
  ValueDisplay,
} from './Counter.styled';
import { CounterProps } from './Counter.types';

export const Counter: React.FC<CounterProps> = ({
  min = 0,
  max = Number.POSITIVE_INFINITY,
  onChange,
  pluralRules,
  initialValue = min,
}) => {
  const [value, setValue] = useState(initialValue);
  const isIncrementDisabled = value >= max;
  const isDecrementDisabled = value <= min;

  const updateValue = (n: number): void =>
    setValue((prevValue) => prevValue + n);

  const handleIncrement = (): void => {
    if (isIncrementDisabled) {
      return;
    }
    onChange(value + 1);
    updateValue(1);
  };
  const handleDecrement = (): void => {
    if (isDecrementDisabled) {
      return;
    }
    onChange(value - 1);
    updateValue(-1);
  };

  const getPluralForm = (): string => {
    return pluralRules ? pluralRules(value) : '';
  };

  return (
    <DefaultThemed>
      <CounterContainer>
        <ButtonWrapper
          type="button"
          data-e2e="counter-decrement"
          noMinWidth={true}
          size="small"
          onClick={handleDecrement}
          disabled={value === min}
        >
          <MinusIcon />
        </ButtonWrapper>
        <ValueDisplay data-e2e="counter-value-display">{`${value} ${getPluralForm()}`}</ValueDisplay>
        <ButtonWrapper
          type="button"
          data-e2e="counter-increment"
          noMinWidth={true}
          size="small"
          onClick={handleIncrement}
          disabled={value === max}
        >
          <PlusIcon />
        </ButtonWrapper>
      </CounterContainer>
    </DefaultThemed>
  );
};
